<template>
    <div class="index-main">
        <header-bar tab-index="2"/>

        <div class="solution-container">
            <div class="mes-header">
                <img src="../../resource/img/header.jpg"/>
                <div class="mes-title">解决方案</div>
            </div>

            <div class="solution-body">
                <div class="index-container">
                    <img src="../../resource/img/solution/4.png" style="width: 100%;">
                    <img src="../../resource/img/solution/2.png" style="width: 100%;">
                    <img src="../../resource/img/solution/3.png" style="width: 100%;">

                    <div class="pd-page-content">
                        <p>MES_Pro 数字化工厂是一种以数字技术为核心，融合了制造执行系统（MES）、高级计划与排程（APS）、质量管理系统（QMS）核心业务系统，并结合轻量级进销存管理（ERP）、客户管理（CRM）、产品生命周期管理（PLM）、库存管理（WMS） ，实现生产过程的数字化、智能化、可视化的新型生产模式。同时沣同MES_Pro充分考虑企业现有数字化系统，可以与常用ERP系统、财务系统进行数据对接，实现自动记账。</p>
                        <p>时代在变，数据成为最重要的生产要素。未来已来，数字化转型已经成为领先企业的必然选择。</p>
                    </div>
                </div>
            </div>
        </div>

        <side-bar/>
        <footer-bar/>
    </div>
</template>

<script>
import HeaderBar from '../../components/header';
import FooterBar from '../../components/footer';
import SideBar from '../../components/sider';
import '../../resource/css/common.css';

export default {
    name: "solution",
    components: {
        'header-bar': HeaderBar,
        'footer-bar': FooterBar,
        'side-bar': SideBar,
    }
}
</script>

<style scoped>
.solution-body {
    padding: 30px;
}

.pd-page-content {
    margin-top: 30px;
}

.pd-page-content p {
    text-indent: 2em;
}
</style>
